import React from 'react';
import { formatCurrency } from '../utils/taxCalculations';
import { getToggleData } from '../utils/taxSources';
import './SimulationToggles.css';

function SimulationToggles({ simulations, onToggle, savings }) {
  const toggles = getToggleData();

  const anyActive = Object.values(simulations).some(value => value);

  return (
    <div className="simulation-toggles">
      <div className="toggles-grid">
        {toggles.map((toggle) => (
          <div
            key={toggle.id}
            className={`toggle-card ${simulations[toggle.id] ? 'active' : ''}`}
          >
            <div className="toggle-header">
              <span className="toggle-icon">{toggle.icon}</span>
              <h3>{toggle.title}</h3>
            </div>
            
            <p className="toggle-description">{toggle.description}</p>
            
            <div className="toggle-stats">
              <div className="stat">
                <span className="stat-label">Potential Revenue</span>
                <span className="stat-value">{toggle.revenue}</span>
              </div>
            </div>

            <button
              type="button"
              className={`toggle-button ${simulations[toggle.id] ? 'active' : ''}`}
              onClick={() => onToggle(toggle.id)}
              aria-pressed={simulations[toggle.id]}
            >
              <span className="toggle-track">
                <span className="toggle-thumb" />
              </span>
              <span className="toggle-label">
                {simulations[toggle.id] ? 'Active' : 'Inactive'}
              </span>
            </button>

            <p className="toggle-source">Source: {toggle.source}</p>
          </div>
        ))}
      </div>

      {anyActive && (
        <div className="savings-summary">
          <div className="savings-icon">🎉</div>
          <div className="savings-content">
            <h4>Your Potential Savings</h4>
            <p className="savings-description">
              With the selected policy changes, you could save:
            </p>
            <div className="savings-amounts">
              <div className="savings-item">
                <span className="savings-value">{formatCurrency(savings.annual)}</span>
                <span className="savings-period">per year</span>
              </div>
              <div className="savings-item">
                <span className="savings-value">{formatCurrency(savings.monthly)}</span>
                <span className="savings-period">per month</span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="simulation-disclaimer">
        <p>
          <strong>Note:</strong> These simulations are simplified models for educational purposes. 
          Actual policy impacts would depend on many factors including implementation costs, 
          economic effects, and political considerations.
        </p>
      </div>
    </div>
  );
}

export default SimulationToggles;
